<template>
	<v-container fill-height pa-0>
		<v-row no-gutters :align="'center'">
			<v-col cols="12" sm="12" md="6">
				<img :src="require('../assets/images/logo-confipetrol-dark.jpg')" class="login__logo" />
			</v-col>
			<v-col cols="12" sm="12" md="6">
				<!-- <form-login /> -->
				<div class="d-flex flex-column w-100">
					<h1 class="form__title text-center">Identificarse</h1>
					<span class="form__caption text-center">Bienvenido</span>
					<v-alert
						class="w-100 text-center mt-5"
						color="red"
						dense
						outlined
						text
						type="error"
						v-text="error"
						v-if="error"
					></v-alert>
					<v-btn class="mt-5" color="warning" tabindex="3" @click="redirectLogin()">
						Iniciar de sesión
					</v-btn>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions } from 'vuex';
// import FormLogin from '@/components/auth/FormLogin/index.vue';

export default {
	name: 'Login',
	data: () => ({
		error: null,
		urlApi: process.env.VUE_APP_API_BASE_URL,
	}),
	mounted() {
		this.validateSession();
	},
	methods: {
		...mapActions('auth', ['setSession']),
		async validateSession() {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			if (urlParams.has('error')) {
				this.error = urlParams.get('error');
			} else if (urlParams.has('token')) {
				const { ok, message } = await this.setSession({
					email: '',
					token: urlParams.get('token'),
				});
				if (ok) {
					this.error = message;
					this.$router.push('/dashboard');
				} else {
					this.error = message;
				}
			}
		},
		redirectLogin() {
			location.href = `${this.urlApi}/auth/login`;
		},
	},
	// components: { FormLogin },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/login.scss';
</style>
